export function formatDate(value?: string) {
  if (!value) return "-";
  return new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(new Date(value));
}

/** A status standing on its own (badge, filter option) starts with a capital. */
export function titleStatus(status: string) {
  const text = labelStatus(status);
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function labelStatus(status: string) {
  return status.replaceAll("_", " ");
}
